import React, { useState, useEffect } from "react";
import MenubarAdmin from "../../layouts/MenubarAdmin";
import { useSelector } from "react-redux";
import { getOrdersAdmin, updateStatusOrder } from "../../function/admin";
import { toast } from "react-toastify";
import { Tabs, Table, Button, Input } from "antd";
import PaymentProofPopup from "./PaymentProofPopup";
import DownloadPopup from "./DownloadPopup";
import { FolderViewOutlined } from '@ant-design/icons';
import * as XLSX from "xlsx";


const { TabPane } = Tabs;
const { Search } = Input;

const Orders = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [orders, setOrders] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [downloadPopupVisible, setDownloadPopupVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDuplicatesOnly, setShowDuplicatesOnly] = useState(false);



  useEffect(() => {
    loadData();
  }, []);

  // const loadData = () => {
  //   getOrdersAdmin(user.token).then((res) => {
  //     setOrders(res.data);
  //   });
  // };


  // ตรวจหมายเลขที่ซ้ำกัน
  const getDuplicateOrders = () => {
    return orders.filter(order => duplicateRefs.includes(order.referenceNumber));
  };

  const loadData = () => {
    getOrdersAdmin(user.token).then((res) => {
      const sortedOrders = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setOrders(sortedOrders);
    });
  };

  const findDuplicateReferences = (orders) => {
    const refCount = {};
    orders.forEach(order => {
      if (order.referenceNumber && order.referenceNumber !== "0") {
        refCount[order.referenceNumber] = (refCount[order.referenceNumber] || 0) + 1;
      }
    });
    return Object.keys(refCount).filter(ref => refCount[ref] > 1);
  };

  const duplicateRefs = findDuplicateReferences(orders);



  const handleChangeStatus = (orderId, orderstatus) => {
    updateStatusOrder(user.token, orderId, orderstatus).then((res) => {
      toast.info("Updated " + res.data.orderstatus + " Success");
      loadData();
    });
  };



  const handleOpenPopup = (order) => {
    setSelectedOrder(order);
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const handleOpenDownloadPopup = (order) => {
    setSelectedOrder(order);
    setDownloadPopupVisible(true);
  };

  const handleCloseDownloadPopup = () => {
    setDownloadPopupVisible(false);
  };


  const handleExportExcel = () => {
    const exportData = filteredOrders
      .filter((order) => order.orderstatus === "Completed")
      .map((order) => {
        const productList = order.products
          .map((p) => {
            const title = p.product?.title || "สินค้านี้ถูกลบ";
            return `${title} (${p.count} x ${p.price})`;
          })
          .join(", ");

        return {
          "ชื่อผู้ใช้": order.orderdBy?.username || "ไม่พบผู้ใช้",
          "เลขอ้างอิง": order.referenceNumber || "-",
          "วันที่": new Date(order.createdAt).toLocaleDateString("th-TH"),
          "ราคารวมสุทธิ": order.cartTotal,
          "สถานะ": order.orderstatus,
          "ประเภทการชำระเงิน":
            order.paymentMethod === "bankTransfer"
              ? "โอนผ่านบัญชีธนาคาร"
              : order.paymentMethod === "stripe"
                ? "ชำระผ่านบัตรเครดิต"
                : order.paymentMethod === "cod"
                  ? "ชำระเงินปลายทาง"
                  : order.paymentMethod === "promptpay"
                    ? "PromptPay"
                    : "ไม่ระบุ",
          "ชื่อผู้รับ": order.orderdBy?.address?.name || "ไม่พบชื่อผู้รับ",
          "โทรศัพท์": order.orderdBy?.address?.phone || "ไม่พบเบอร์โทร",
          "อีเมล": order.orderdBy?.address?.email || "ไม่พบอีเมล",
          "ที่อยู่จัดส่ง": order.orderdBy?.address?.address || "ไม่พบที่อยู่",
          "รายการสินค้า": productList,
        };
      });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Completed Orders");
    XLSX.writeFile(workbook, "completed_orders.xlsx");
  };

  const filteredOrders = showDuplicatesOnly
    ? getDuplicateOrders()
    : orders.filter((order) =>
      order.orderNumber && order.orderNumber.includes(searchTerm)
    );

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
      fixed: "left", // ✅ Fix คอลัมน์ไว้ด้านซ้าย
      width: 80, // ✅ แนะนำใส่ความกว้างเพื่อให้ Table render สวย
      render: (text, record, index) => index + 1, // ✅ เริ่มจาก 1
    },
    {
      title: "ชื่อผู้ใช้",
      dataIndex: "orderdBy",
      render: (item) => <>{item?.username || "No user"}</>,
    },
    {
      title: "Reference Number",
      dataIndex: "referenceNumber",
      key: "referenceNumber",
      render: (text) => (
        <span style={{ color: duplicateRefs.includes(text) ? "red" : "black" }}>
          {text}
        </span>
      ),
    },
    {
      title: "วันที่",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => {
        const formattedDate = new Date(date).toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: "รายการสินค้า",
      dataIndex: "products",
      render: (products) => (
        <ol>
          {products.map((p) => (
            <li key={p.product?._id}>
              {p.product ? (
                p.product.title ? p.product.title : "Product Title Not Available"
              ) : (
                "สินค้าถูกลบไปแล้ว"
              )}{" "}
              <b>
                {p.price} x {p.count}
              </b>
            </li>
          ))}
        </ol>
      ),
    },
    {
      title: "ราคารวมสุทธิ",
      dataIndex: "cartTotal",
      key: "cartTotal",
    },
    {
      title: "วิธีการรับสินค้า",
      dataIndex: "deliveryMethod",
      render: (deliveryMethod) => (
        <>
          {deliveryMethod === "branchPickup" && "รับที่สาขา"}
          {deliveryMethod === "homeDelivery" && "จัดส่งถึงบ้าน"}
        </>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "orderstatus",
      key: "orderstatus",
    },
    {
      title: "ประเภทการชำระเงิน",
      dataIndex: "paymentMethod",
      render: (paymentMethod) => (
        <>
          {paymentMethod === "bankTransfer" && "โอนผ่านบัญชีธนาคาร"}
          {paymentMethod === "card" && "ชำระผ่านบัตรเครดิต"}
          {paymentMethod === "cod" && "ชำระเงินปลายทาง"}
          {paymentMethod === "promptpay" && "PromptPay"}
        </>
      ),
    },
    {
      title: "หลักฐานการชำระเงิน",
      render: (record) => (
        <Button onClick={() => handleOpenPopup(record)}>View</Button>
      ),
    },
    {
      title: "ที่อยู่จัดส่ง",
      render: (record) => (
        <Button onClick={() => handleOpenDownloadPopup(record)}>Download Invoice</Button>
      ),
    },
    {
      title: "อัพเดทสถานะ",
      render: (record) => {
        // กำหนด class ตาม status
        const statusClass =
          record.orderstatus === "Not Process"
            ? "bg-secondary text-light" // ยังไม่ดำเนินการ
            : record.orderstatus === "Processing"
              ? "bg-warning"
              : record.orderstatus === "Shipping"
                ? "bg-info text-dark" // กำลังจัดส่ง
                : record.orderstatus === "Delivered"
                  ? "bg-primary text-light" // จัดส่งแล้ว
                  : record.orderstatus === "Completed"
                    ? "bg-success text-light"
                    : record.orderstatus === "Cancelled"
                      ? "bg-danger text-light"
                      : "";

        return (
          <select
            value={record.orderstatus}
            onChange={(e) => handleChangeStatus(record._id, e.target.value)}
            style={{ width: "200px", alignSelf: "center" }}
            className={`form form-control ${statusClass}`}
          >
            <option value="Not Process">ยังไม่ดำเนินการ</option>
            <option value="Processing">กำลังดำเนินการ</option>
            <option value="Shipping">กำลังจัดส่ง</option>
            <option value="Delivered">จัดส่งแล้ว</option>
            <option value="Completed">เสร็จสิ้น</option>
            <option value="Cancelled">ยกเลิก</option>
          </select>
        );
      },
    }
  ];



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2">
          <MenubarAdmin />
        </div>
        <div className="col-md-10">
          <h4 className="text-center mt-3">คำสั่งซื้อ</h4>
          <div className="mb-3">
            <Search
              placeholder="ค้นหา Order Number..."
              allowClear
              enterButton="Search"
              size="large"
              onSearch={(value) => setSearchTerm(value)}
            />
          </div>
          <Button
            onClick={() => setShowDuplicatesOnly(!showDuplicatesOnly)}
            type="primary"
            className="mb-3"
          >
            {showDuplicatesOnly ? "ดูคำสั่งซื้อทั้งหมด" : "ดูเฉพาะคำสั่งซื้อที่ซ้ำกัน"}
          </Button>
          <Button onClick={handleExportExcel} type="default" className="mb-3" style={{ marginLeft: "10px" }}>
            Export เป็น Excel
          </Button>
          <Tabs defaultActiveKey="2">
            <TabPane
              tab={
                <span>
                  <FolderViewOutlined /> 1
                </span>
              }
              key="1"
            >
              {filteredOrders.map((item) => (
                <div key={item._id} className="card mb-3">
                  <div className="card-body">
                    <h5 className="card-title">
                      Order by <b>{item.orderdBy?.username}</b>
                    </h5>
                    {/* เพิ่มเลขอ้างอิง */}
                    <p className="card-text">
                      <b>Reference Number:</b> {item.referenceNumber || "N/A"}
                    </p>
                    {/* เพิ่มวันที่สร้าง */}
                    <p className="card-text">
                      <b>Created At:</b>{" "}
                      {new Date(item.createdAt).toLocaleDateString("th-TH", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </p>
                    <p className="card-text">Status: {item.orderstatus}</p>
                    <select
                      value={item.orderstatus}
                      onChange={(e) => handleChangeStatus(item._id, e.target.value)}
                      style={{ width: "200px", alignSelf: "center" }}
                      className={`form form-control ${item.orderstatus === "Processing"
                        ? "bg-warning"
                        : item.orderstatus === "Cancelled"
                          ? "bg-danger text-light"
                          : item.orderstatus === "Completed"
                            ? "bg-success text-light"
                            : ""
                        }`}
                    >
                      <option value="Not Process">Not Process</option>
                      <option value="Processing" className="bg-warning text-dark">
                        Processing
                      </option>
                      <option value="Cancelled" className="bg-danger text-light">
                        Cancelled
                      </option>
                      <option value="Completed" className="bg-success text-light">
                        Completed
                      </option>
                    </select>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>Price</th>
                          <th>Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        {item.products.map((p) => (
                          <tr key={p.product._id}>
                            <td>{p.product.title}</td>
                            <td>{p.price}</td>
                            <td>{p.count}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={3}>
                            Total Price: <b>{item.cartTotal}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-3">
                      <Button onClick={() => handleOpenPopup(item)}>View Payment Proof</Button>
                    </div>
                    <div className="mt-3">
                      <Button onClick={() => handleOpenDownloadPopup(item)}>Download Invoice</Button>
                    </div>
                  </div>
                </div>
              ))}
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FolderViewOutlined /> 2
                </span>
              }
              key="2"
            >
              <Table dataSource={filteredOrders} columns={columns} scroll={{ x: 'max-content' }} />
            </TabPane>
            <TabPane
              tab={
                <span>
                  <FolderViewOutlined /> 3
                </span>
              }
              key="3"
            >
              {/* Alternate view of the table if needed */}
            </TabPane>
          </Tabs>
        </div>
      </div>
      {popupVisible && selectedOrder && (
        <PaymentProofPopup
          visible={popupVisible}
          onClose={handleClosePopup}
          order={selectedOrder}
        />
      )}
      {downloadPopupVisible && selectedOrder && (
        <DownloadPopup
          visible={downloadPopupVisible}
          onClose={handleCloseDownloadPopup}
          order={selectedOrder}
        />
      )}
    </div>
  );
};

export default Orders;
